import { render, staticRenderFns } from "./AliasName.vue?vue&type=template&id=40fa79cc"
import script from "./AliasName.vue?vue&type=script&lang=js"
export * from "./AliasName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports